import React from 'react';
import noDataIcon from '../../../../assets/icons/charts/nodata-chart.svg';
import { Typography } from '../../../widgets/Typography';
import { Contact } from '../../../../shared/constants/contact';

type WidgetErrorCompound = React.FC<React.PropsWithChildren> & {
  Label: typeof WidgetErrorLabel;
};

const WidgetError: WidgetErrorCompound = ({ children }) => {
  return (
    <div className="mt-16 flex flex-col items-center justify-center">
      <img
        aria-hidden
        src={noDataIcon}
        className="mb-4 h-8 w-8"
        alt="No Data"
      />
      {children ?? (
        <WidgetErrorLabel>
          Sorry, we can't display the data for this widget. Please get in touch
          with us at&nbsp;
          <a
            href={`mailto:${Contact.Email}`}
            className="font-semibold text-blue-700 hover:underline"
          >
            {Contact.Email}
          </a>
        </WidgetErrorLabel>
      )}
    </div>
  );
};

function WidgetErrorLabel({ children }: React.PropsWithChildren) {
  return (
    <Typography variant="body-sm" className="text-grey-500 text-pretty">
      {children}
    </Typography>
  );
}

WidgetError.Label = WidgetErrorLabel;

export default WidgetError;
